<template>
  <div class="confirm-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="stage">
          <!-- 蓝湖星斑特效层：叠在弹框背后，四周星光可见 -->
          <img class="star-fx" :src="imgStarFx" alt="" />
          <div class="card">
            <div class="header">
              <div class="title">权益领取温馨提示</div>
            </div>
            <div class="content" @touchmove.stop>
              <p class="intro">
                本次活动每位客户活动期间仅限领取1次权益，请您谨慎确认是否立即领取！本月您已达标可领取当前等级对应礼品！
              </p>
              <div class="tip-box">
                <p class="tip-p">现在领取，次月客户等级升级，也无法申领更高档位礼品；</p>
                <p class="tip-p">暂不领取，次月客户等级提升，可领取更高价值礼品。</p>
                <p class="tip-p">最迟领取时间为{{ [7, 9].includes(confirmIsPopup) ? '2026年10月31日23:59' : [8, 10].includes(confirmIsPopup) ? '2026年11月30日23:59' : '' }}前。</p>
              </div>
              <div class="examples" v-if="[7, 9].includes(confirmIsPopup)">
                <p class="example-p">例如：</p>
                <p class="example-p">
                  客户8月开户，9月5日系统判断显示等级提升为白金，但客户选择不领取奖励，2026年10月8日系统判断等级较9月5日结果未提升，仍可于10月8日10:00至10月31日23:59期间领取白金等级礼品。
                </p>
                <p class="example-p">
                  客户8月开户，9月5日系统判断显示等级提升为白金，可于9月5日10:00至9月30日23:59抽取白金等级礼品，领取完毕后，若10月8日等级进一步提升为黑金，也不可再领取黑金对应礼品。
                </p>
                <p class="example-p">
                  客户8月开户，9月5日系统判断显示等级提升为白金，但客户选择不领取奖励，待2026年10月8日系统判断等级进一步提升至黑金后，可于10月8日10:00至10月31日23:59期间领取黑金对应礼品。
                </p>
              </div>
              <div class="examples" v-if="[8, 10].includes(confirmIsPopup)">
                <p class="example-p">例如：</p>
                <p class="example-p">
                  客户9月开户，10月8日系统判断显示等级提升为白金，但客户选择不领取奖励，2026年11月5日系统判断等级较10月8日结果未提升，仍可于11月5日10:00至11月30日23:59期间领取白金等级礼品。
                </p>
                <p class="example-p">
                  客户9月开户，10月8日系统判断显示等级提升为白金，可于10月8日10:00至10月31日23:59抽取白金等级礼品，领取完毕后，若11月5日等级进一步提升为黑金，也不可再领取黑金对应礼品。
                </p>
                <p class="example-p">
                  客户9月开户，10月5日系统判断显示等级提升为白金，但客户选择不领取奖励，待2026年11月5日系统判断等级进一步提升至黑金后，可于11月5日10:00至11月30日23:59期间领取黑金对应礼品。
                </p>
              </div>
            </div>
            <div class="btns">
              <img class="btns-img" :src="imgBtns" alt="" />
              <button
                class="btn-hit btn-claim"
                type="button"
                aria-label="现在领取"
                @click.stop="onClaim"
              />
              <button
                class="btn-hit btn-cancel"
                type="button"
                aria-label="暂不领取"
                @click.stop="onCancel"
              />
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmIsPopup: { // 是否弹确认弹框，返回0不弹窗
      type: Number,
      default: null
    }
  },
  data() {
    return {
      imgBtns: require('@/assets/imgs/xibNewCustomerGift/luyuanConfirmBtns.png'),
      imgStarFx: require('@/assets/imgs/xibNewCustomerGift/luyuanStarFx.png')
    }
  },
  methods: {
    onClaim() {
      this.$emit('confirm')
    },
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
/* 设计稿 750 ÷ 2 */
.confirm-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .stage {
    position: relative;
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* 星斑特效：比弹框更宽，顶部略探出以露出星光 */
  .star-fx {
    position: absolute;
    left: 0;
    top: -90px;
    width: 100vw;
    object-fit: contain;
    object-position: center top;
    pointer-events: none;
    z-index: 0;
  }

  .card {
    position: relative;
    z-index: 1;
    width: 317.5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    filter: drop-shadow(0 0 10px rgba(188, 244, 246, 0.95));
  }

  /* 拱形顶：透明区域露出遮罩，形成花瓣顶轮廓 */
  .header {
    width: 297px;
    height: 70.5px;
    background: url('~@/assets/imgs/xibNewCustomerGift/luyuanModalTitleBg.png')
      no-repeat center top;
    background-size: 297px 70.5px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    z-index: 2;
  }

  .title {
    font-size: 21px;
    color: #1b899f;
    line-height: 24px;
    text-align: center;
    padding-bottom: 6px;
  }

  .content {
    width: 297px;
    padding: 8px 20px 120px;
    box-sizing: border-box;
    background: #e8fdff;
    max-height: min(65vh, calc(100dvh - 200px));
    overflow: auto;
    color: #1b899f;
    position: relative;
    top: -1px;
    z-index: 1;
  }

  .intro {
    margin: 0;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
  }

  .tip-box {
    margin-top: 11.5px;
    padding: 11px;
    box-sizing: border-box;
    background: #bcf4f6;
    border-radius: 5px;
  }

  .tip-p {
    margin: 0;
    font-size: 12px;
    line-height: 16px;
    color: #1b899f;
  }

  .examples {
    margin-top: 11.5px;
  }

  .example-p {
    margin: 0;
    font-size: 12px;
    line-height: 16px;
    color: #1b899f;
    text-align: justify;

    &:last-child {
      margin-bottom: 0;
    }
  }

  /* 信封底 + 双按钮：使用蓝湖完整切图 635×247，叠在白底内容上避免透黑 */
  .btns {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 317.5px;
    height: 123.5px;
    z-index: 3;
  }

  .btns-img {
    display: block;
    width: 317.5px;
    height: 123.5px;
  }

  .btn-hit {
    position: absolute;
    top: 40px;
    width: 130px;
    height: 38px;
    padding: 0;
    border: 0;
    background: transparent;
    outline: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .btn-claim {
    left: 22px;
  }

  .btn-cancel {
    right: 22px;
  }
}
</style>
